// extracted by mini-css-extract-plugin
export default {"title":"Alerts_title__Nhi4h","content":"Alerts_content__c+c3D"};